import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { Identifier } from '../models/Identifier';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput';

/**
 * no description
 */
export class RestoreEksNamespaceApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Start an Eks Namespace restore from snapshot
   * @param projectId The project ID
   * @param id The inventory item ID
   * @param snapshotId The snapshot ID
   * @param restoreEksNamespaceInput The request body for restoring the instance
   */
  public async restoreEksNamespace(projectId: string, id: string, snapshotId: string, restoreEksNamespaceInput: RestoreEksNamespaceInput, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("RestoreEksNamespaceApi", "restoreEksNamespace", "projectId");
    }


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("RestoreEksNamespaceApi", "restoreEksNamespace", "id");
    }


    // verify required parameter 'snapshotId' is not null or undefined
    if (snapshotId === null || snapshotId === undefined) {
      throw new RequiredError("RestoreEksNamespaceApi", "restoreEksNamespace", "snapshotId");
    }


    // verify required parameter 'restoreEksNamespaceInput' is not null or undefined
    if (restoreEksNamespaceInput === null || restoreEksNamespaceInput === undefined) {
      throw new RequiredError("RestoreEksNamespaceApi", "restoreEksNamespace", "restoreEksNamespaceInput");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/inventory/{id}/snapshots/{snapshotId}/restore-eks-namespace'
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
      .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreEksNamespaceInput, "RestoreEksNamespaceInput", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class RestoreEksNamespaceApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to restoreEksNamespace
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async restoreEksNamespaceWithHttpInfo(response: ResponseContext): Promise<HttpInfo<Identifier >> {
    if (isCodeInRange("202", response.httpStatusCode)) {
      const body: Identifier = ObjectSerializer.deserialize(
        await response.body.json(),
        "Identifier", ""
      ) as Identifier;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Snapshot or restore account not found", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: Identifier = await response.body.json() as Identifier;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
